import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const currentYear = new Date().getFullYear(); // Dynamic year

  return (
    <div className="footer_wrapper">
      <footer className="footerMain">
          <p>
            Copyright {currentYear} <Link to="https://algovisolutions.com/">Linguistica Services LLC</Link>. All rights reserved
          </p>
      </footer>
    </div>
  );
}

export default Footer;
